import React from 'react';

export interface FormCheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
  backgroundColor?: 'primary' | 'secondary';
}

export const FormCheckbox: React.FC<FormCheckboxProps> = ({
  label,
  backgroundColor = 'primary',
  className = '',
  ...props
}) => {
  return (
    <div>
      <label className="flex items-center cursor-pointer">
        <input
          {...props}
          type="checkbox"
          className={`mr-2 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 ${className}`}
          style={{
            accentColor: 'var(--color-accent)',
            ...props.style
          } as React.CSSProperties}
        />
        <span className="text-sm font-medium" style={{ color: 'var(--color-text-primary)' }}>
          {label}
        </span>
      </label>
    </div>
  );
};

